import { useModals, Box, Button, Card, Stack, Title } from "@skailer-com/uikit";
import { TimeOffSortModal } from "@/pages/settings/time-off/index/widgets/TimeOffSortModal.tsx";
import { useTimeOffCategories } from "@/queries/use-time-off.query.ts";
import analyticsService, { analyticEvents } from "@/services/analytics-service.ts";
import { useTranslation } from "react-i18next";
import { useEffectOnce } from "react-use";

export function TimeOffSettingsTabIndex() {
  const { t } = useTranslation();
  const { data: categories, isPending } = useTimeOffCategories({ enabled: true });
  const { openModal } = useModals();

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.timeOffs.categoriesViewed);
  });

  return (
    <Box>
      <Stack
        direction={"horizontal"}
        gap={"md"}
        items={"center"}
        justify={"between"}
        className={"pt-6 pb-4"}
      >
        <Title
          header={t("time_off:title")}
          paddingTop={false}
          paddingBottom={false}
          size={"lg"}
          caption={t("time_off:settings_description")}
        />

        <Button
          onClick={() => {
            openModal(TimeOffSortModal);
          }}
        >
          {t("common:reorder")}
        </Button>
      </Stack>

      <Stack
        direction={"horizontal"}
        gap={"md"}
        className={"grid md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 pt-4"}
      >
        {isPending ? (
          <Card isLoading={true} />
        ) : (
          <>
            {categories?.map((timeOff) => (
              <Card
                header={timeOff.title}
                key={timeOff.id}
                emoji={timeOff.emoji}
                caption={timeOff.description}
                to={`/settings/time-off/categories/${timeOff.id}`}
                description={t("plurals:policy", { count: timeOff.policies_count })}
              />
            ))}
            <Card
              icon={"fa-plus"}
              header={t("time_off:create_new")}
              to={`/settings/time-off/categories/new`}
              variant={"action"}
            />
          </>
        )}
      </Stack>
    </Box>
  );
}
